/* eslint-disable no-console, react/no-render-return-value */

import 'babel-polyfill';
import * as React from 'react';
import { ReactElement } from 'react';
import * as ReactDOM from 'react-dom';
import { AppContainer } from 'react-hot-loader';
import './services/ErrorReportingService';

import routes from './routes';

const render = (component: ReactElement<any>) =>
  ReactDOM.render(
    <AppContainer>{component}</AppContainer>,
    document.getElementById('react-app')
  );
render(routes);
if (module.hot) {
  // tslint:disable-next-line no-console
  console.log('module.hot is present');
  module.hot.accept('./routes', () => {
    const reloadableRoutes = require('./routes').default;
    render(reloadableRoutes);
  });
}



// WEBPACK FOOTER //
// ./src/app.tsx